import React from 'react';
import styled from 'styled-components';
import ICON_COMPONENT_VERSION_FILTER_EMPTY from '../../../../assets/search-error.svg';

const EmptyViewWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
`;

const EmptyFilterView = () => {
    return (
        <EmptyViewWrapper>
            <div style={{ padding: '25px 0', textAlign: 'center' }}>
                <img alt="component versions" src={ICON_COMPONENT_VERSION_FILTER_EMPTY} width="151" height="167" />
                <h3>
                    {`We couldn't find any components/labels`} <br />
                    that matched your search
                </h3>
            </div>
        </EmptyViewWrapper>
    );
};

export default EmptyFilterView;
